import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { MatTabsModule } from '@angular/material/tabs'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { BaseChartDirective } from 'ng2-charts'

import { NoDataComponent } from '../../utils/no-data/no-data.component'
import { SharedModule } from '../shared/shared.module'
import { LineBarChartSyncComponent } from './charts/line-bar-chart-sync/line-bar-chart-sync.component'
import { LineChartComponent } from './charts/line-chart/line-chart.component'
import { ChartUtilitiesModule } from './charts/utils/chart-utilities.module'
import { ClosingPriceComponent } from './closing-price/closing-price.component'
import { CurrentPriceComponent } from './current-price/current-price.component'
import { HistoricalPriceComponent } from './historical-price/historical-price.component'
import { OneMonthComponent } from './historical-price/one-month/one-month.component'
import { CurrentComponent } from './premium-discount/current/current.component'
import { PremiumDiscountComponent } from './premium-discount/premium-discount.component'
import { PriceComponent } from './price.component'

@NgModule({
  declarations: [
    PriceComponent,
    CurrentPriceComponent,
    ClosingPriceComponent,
    HistoricalPriceComponent,
    OneMonthComponent,
    PremiumDiscountComponent,
    CurrentComponent,
    LineChartComponent,
    LineBarChartSyncComponent,
    NoDataComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    BaseChartDirective,
    ChartUtilitiesModule,
    FormsModule,
    MatTabsModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
  ],
  exports: [PriceComponent],
})
export class PriceModule {}
